<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>小睿智能筛查管家</el-breadcrumb-item>
      <el-breadcrumb-item>视力筛查人员</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.age" @keyup.enter.native="clicksearch" placeholder="请输入年龄" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Name" label="姓名" min-width="10%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickqrcode(scope.row)">二维码</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clicksublist(scope.row)">视力筛查记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加" name="second" v-if="SubRule_Miniappshaicha_AddVisionScreeningUser">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">姓名(必填)</span>
          </label>
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">年龄(必填)</span>
          </label>
          <el-input v-model="addForm.age"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <el-tab-pane label="视力筛查记录" name="six" disabled="disabled">
      <MiniappshaichaVisionScreeningUserSub ref="SubVuesix" v-on:triggerFunc="BackToFirst(0)"></MiniappshaichaVisionScreeningUserSub>
    </el-tab-pane>

    <!-- 弹出框 -->
    <el-dialog :title="dialogtitle" :visible.sync="dialogQrcode" width="240px" @close="closeCode" :close-on-click-modal="false">
      <div class="qrcode" ref="qrCodeUrl"></div>
      <el-button class="downloadqrcode" type="primary" @click="clickdownload">下载二维码</el-button>
    </el-dialog>

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import MiniappshaichaVisionScreeningUserSub from '@/componentsSubVue/MiniappshaichaVisionScreeningUserSub.vue'
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
Vue.use(VueAxios, axios)

export default {
  components: {
    MiniappshaichaVisionScreeningUserSub
  },
  name: 'MyMiniappshaichaVisionScreeningUser',
  data () {
    return {
      activeName: 'first',
      addForm: {
        name: '',
        age: ''
      },
      // 查询
      keywords: {
        name: '',
        age: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogQrcode: false,
      SubRule_Miniappshaicha_AddVisionScreeningUser: false,
      dialogtitle: ''
    }
  },
  mounted () {
    this.apiGetMiniappShaichaVisionScreeningUserNum()
    this.apiGetMiniappShaichaVisionScreeningUserList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Miniappshaicha_AddVisionScreeningUser', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Miniappshaicha_AddVisionScreeningUser = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clickadd () {
      this.apiAddMiniappShaichaVisionScreeningUser()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksublist (row) {
      this.activeName = 'six'
      this.$refs.SubVuesix.LoadData({ name: '', params: { Qrcode: row.Qrcode } })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetMiniappShaichaVisionScreeningUserNum()
      this.apiGetMiniappShaichaVisionScreeningUserList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetMiniappShaichaVisionScreeningUserList()
    },
    clickqrcode (row) {
      var that = this
      that.dialogQrcode = true
      that.dialogtitle = row.Name
      that.$nextTick(() => {
        var qrcode = new QRCode(that.$refs.qrCodeUrl, {
          text: row.Qrcode, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    // 关闭弹框,清除已经生成的二维码
    closeCode () {
      this.$refs.qrCodeUrl.innerHTML = ''
    },
    clickdownload () {
      var that = this
      const canvas = document.createElement('canvas')
      // 获取要生成图片的 DOM 元素
      const canvasDom = this.$refs.qrCodeUrl
      // 获取指定的宽高
      const width = parseInt(window.getComputedStyle(canvasDom).width)
      const height = parseInt(window.getComputedStyle(canvasDom).height)
      // 宽高扩大 2 倍 处理图片模糊
      canvas.width = width
      canvas.height = height
      canvas.style.width = width + 'px'
      canvas.style.height = height + 'px'
      const context = canvas.getContext('2d')
      context.scale(1, 1)
      const options = {
        backgroundColor: null,
        canvas: canvas,
        useCORS: true
      }
      html2canvas(canvasDom, options).then(canvas => {
        // 生成图片地址
        const saveUrl = canvas.toDataURL('image/png')
        const aLink = document.createElement('a')
        const blob = this.base64ToBlob(saveUrl)
        const evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', true, true)
        aLink.download = that.dialogtitle + '.png'
        aLink.href = URL.createObjectURL(blob)
        aLink.click()
      })
    },
    // 这里把图片转base64
    base64ToBlob (code) {
      const parts = code.split(';base64,')
      const contentType = parts[0].split(':')[1]
      const raw = window.atob(parts[1])
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    },
    apiGetMiniappShaichaVisionScreeningUserNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name,
        age: that.keywords.age
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniappShaichaVisionScreeningUserNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMiniappShaichaVisionScreeningUserList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name,
        age: that.keywords.age
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniappShaichaVisionScreeningUserList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddMiniappShaichaVisionScreeningUser: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.addForm.name,
        age: that.addForm.age
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMiniappShaichaVisionScreeningUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetMiniappShaichaVisionScreeningUserNum()
            that.apiGetMiniappShaichaVisionScreeningUserList()

            // 清空添加
            that.addForm.name = ''
            that.addForm.age = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.qrcode{
    display: inline-block;
    img {
        width: 132px;
        height: 132px;
        background-color: #fff; //设置白色背景色
        padding: 6px; // 利用padding的特性，挤出白边
        box-sizing: border-box;
    }
}

.downloadqrcode {
  display:block;
  margin:0 auto
}
</style>
